import { Injectable } from '@angular/core';

import { Cidade, Estado } from 'models/cidade-estado';

import mockCidades from 'mocks/shared/cidades.json';
import mockEstados from 'mocks/shared/estados.json';

@Injectable()
export class CidadesService {

  private estados: Estado[] = undefined;
  private cidades: Cidade[] = undefined;

  constructor() { }

  private loadEstados(callback): void {
    this.estados = mockEstados.map(estado => new Estado(estado));
    callback(this.estados);
  }

  private loadCidades(callback): void {
    this.cidades = mockCidades.map(cidade => new Cidade(cidade));
    callback(this.cidades);
  }

  public getEstados(): Promise<Estado[]> {
    return new Promise<Estado[]>((resolve) => {
      if (this.estados) {
        resolve(this.estados);
      } else {
        this.loadEstados(resolve);
      }
    });
  }

  public getEstadoBySigla(sigla: string): Promise<Estado> {
    return new Promise<Estado>((resolve, reject) => {
      if (this.estados) {
        resolve(this.estados.filter(uf => uf.sigla === sigla)[0]);
      } else {
        this.loadEstados(
          estados => {
            resolve(estados.filter(uf => uf.sigla === sigla)[0]);
          });
      }
    });
  }

  public getCidadeById(idCidade: number): Promise<Cidade> {
    return new Promise<Cidade>((resolve, reject) => {
      if (this.cidades) {
        resolve(this.cidades.filter(cidade => cidade.id === idCidade)[0]);
      } else {
        this.loadCidades(cidades => {
          resolve(cidades.filter(cidade => cidade.id === idCidade)[0]);
        });
      }
    });
  }

  public getCidades(siglaEstado: string): Promise<Cidade[]> {
    return new Promise<Cidade[]>((resolve, reject) => {
      if (this.cidades) {
        resolve(this.cidades.filter(cidade => cidade.uf === siglaEstado));
      } else {
        this.loadCidades(cidades => {
          resolve(cidades.filter(cidade => cidade.uf === siglaEstado));
        });
      }
    });
  }

}
